import type {
    AssetsMap,
    MerchCard,
    ProgramItem,
    SpeakerCardItem,
    SponsorLogo,
    TrackCardItem,
} from "../types/site";

export const trackTabs = [
    "Войти в IT",
    "Development",
    "Management",
    "Design",
    "Data",
    "GameDev",
] as const;

export const speakerTrackTabs = [
    "Войти в IT",
    "Development",
    "Management",
    "Design",
    "Data",
    "GameDev",
] as const satisfies readonly TrackTab[];

export type TrackTab = (typeof trackTabs)[number];
const speakerAvatar = "/assets/avatar.png";

export const trackCards: readonly TrackCardItem<TrackTab>[] = [
    {
        id: "development",
        title: "Development",
        subtitle: "все уровни",
        accent: "green",
        image: "/assets/tracks/track_dev.png",
        review: "Создание современных веб-приложений и платформ. Разберём актуальные технологии, архитектуру и лучшие практики разработки",
        speakerTab: "Development" as TrackTab,
    },
    {
        id: "management",
        title: "Management",
        subtitle: "все уровни",
        accent: "white",
        image: "/assets/tracks/track_manager.png",
        review: "Управление IT-проектами и командами. Про процессы, планирование, метрики и эффективную коммуникацию",
        speakerTab: "Management" as TrackTab,
    },
    {
        id: "design",
        title: "Design",
        subtitle: "все уровни",
        accent: "green",
        image: "/assets/tracks/track_design.png",
        review: "Дизайн цифровых продуктов: от идеи до интерфейса. UX/UI, визуальные решения и пользовательский опыт",
        speakerTab: "Design" as TrackTab,
    },
    {
        id: "data",
        title: "Data Science, ML, AI",
        subtitle: "все уровни",
        accent: "white",
        image: "/assets/tracks/track_data.png",
        review: "Работа с данными и искусственным интеллектом. Анализ, машинное обучение и применение моделей в реальных задачах",
        speakerTab: "Data" as TrackTab,
    },
    {
        id: "gamedev",
        title: "GameDev",
        subtitle: "все уровни",
        accent: "green",
        image: "/assets/tracks/track_game.png",
        review: "Разработка игр: геймдизайн, движки и продакшн. Как создаются игровые миры и интерактивный опыт",
        speakerTab: "GameDev" as TrackTab,
    },
    {
        id: "entry",
        title: "Войти в IT",
        subtitle: "для новичков",
        accent: "white",
        image: "/assets/tracks/track_entry.png",
        review: "Старт в IT с нуля. Профессии, навыки и шаги, которые помогут выбрать направление и начать карьеру",
        speakerTab: "Войти в IT" as TrackTab,
    },
] as const;

export const speakersByTab: Record<TrackTab, SpeakerCardItem[]> = {
    Development: [
        {
            speakers: [
                {
                    name: "Иван Григорьев",
                    avatar: "/assets/speakers/ivan_grigoriev.png",
                    role: "Инженер отдела проверки качества Drivee",
                },
            ],
            topic: "Машины заменят тестировщиков",
            description: "Применение Self-hosted LLM для UI тестирования мобильного приложения",
        },
        {
            speakers: [
                {
                    name: "Станислав Павлов",
                    avatar: "/assets/speakers/stanislav_pavlov.png",
                    role: "Начальник отдела фронтенд АЭБ",
                },
            ],
            topic: "Server-Driven UI: Фронтенд умер, да здравствует фронтенд!",
            description:
                "Фронтенд больше не определяет интерфейсы — он их исполняет. Разберём, как сервер может управлять структурой UI через JSON-схемы, позволяя выпускать фичи без деплоя и радикально ускорять Time-to-Market",
        },
        {
            speakers: [
                {
                    name: "Владимир Заморщиков",
                    avatar: "/assets/speakers/vladimir_zamorshchikov.png",
                    role: "Инженер отдела мобильной разработки Drivee",
                },
            ],
            topic: "Я больше не нужен? ИИ в мобильной разработке, без паники (почти)",
            description:
                "ИИ уже пишет код, проходит код-ревью (почти) и иногда даже выглядит как идеальный джун. Значит ли это, что рядовые разработчики больше не нужны? Хочу рассказать свой опыт знакомства с ИИ в разработке, как меняется работа с приходом LLM, где они действительно помогают, а где всё ещё требуют человека — и как не только сохранить свою ценность, но и вырасти быстрее с помощью ИИ",
        },
        {
            speakers: [
                {
                    name: "Мария Степанова",
                    avatar: "/assets/speakers/maria_stepanova.png",
                    role: "Backend-разработчик Wildberries",
                },
            ],
            topic: "Как перейти из QA в backend: мой путь в Go-разработку",
            description:
                "В этом выступлении я расскажу о своём переходе из QA в backend-разработку на Go  без идеального старта. Поделюсь реальным опытом: какие шаги помогли мне перейти в разработку, какие навыки из тестирования стали преимуществом и какие ошибки важно не повторять. Также расскажу, как на практике устроена работа backend-разработчика и чего ожидать на старте. Выступление будет полезно тем, кто задумывается о переходе в разработку или уже находится в этом процессе",
        },
        {
            speakers: [
                {
                    name: "Артем Лыткин",
                    avatar: "/assets/speakers/artyom_lytkin.png",
                    role: "Руководитель платформенной команды Drivee",
                },
            ],
            topic: "Армагеддон. Как мы переводили компанию на новую технологичную платформу",
            description:
                "Каждая команда в определенный момент сталкивается с непростым выбором: в начале запуска проекта или при решении задач масштабирования (трафик, команда). Рассмотрим пример из личного опыта, чтобы вы могли сделать свой взвешенный выбор на перепутье",
        },
        {
            speakers: [
                {
                    name: "Состав спикеров пополняется",
                    role: "",
                },
            ],
            pending: true,
        },
    ],
    Management: [
        {
            speakers: [
                {
                    name: "Матвей Бадагуев",
                    avatar: "/assets/speakers/matvey_badaguev.png",
                    role: "Менеджер продукта Drivee",
                },
            ],
            topic: "Где теряется пользователь: от открытия приложения до заказа",
            description:
                "Это история про то, как продакт работает с реальной воронкой, а не абстрактными экранами. На примере регистрации и создания заказа в ride-hailing покажу, какие шаги создавали лишнее трение, как мы убирали обязательные поля, упрощали сценарии, улучшали работу с гео и адресами, и как это влияло на конверсию",
        },
        {
            speakers: [
                {
                    name: "Сергей Протопопов",
                    avatar: "/assets/speakers/sergey_protopopov.png",
                    role: "Генеральный директор BoonMarket",
                },
            ],
            topic: "Boon Market. Как доставить 500'000 заказов за 15 минут",
            description:
                "Как превратить айти-продукт в привычку людей. Длинные стратегии как ориентир для локальных действий или что делать приоритетно сейчас, чтобы быть актуальным сегодня и в будущем. Внедрение ИИ в повседневную жизнь пользователей, дроны и электротранспорт — как строительство инфраструктуры города и села",
        },
        {
            speakers: [
                {
                    name: "Денис Захаров",
                    avatar: "/assets/speakers/denis_zakharov.png",
                    role: "Технический директор Ykt",
                },
            ],
            topic: "“Пора идти работать сварщиком” Любовь и ненависть разработчика к ИИ",
            description:
                "Почему вход в IT стал проще, почему знаний стало нужно меньше (или нет), почему без AI уже «нипоработать» и почему иногда кажется, что проще пойти работать сварщиком",
        },
        {
            speakers: [
                {
                    name: "Владислав Петров",
                    avatar: "/assets/speakers/vladislav_petrov.png",
                    role: "Генеральный директор Ykt",
                },
            ],
            topic: "Как мы вложили 4 млн на игру, выложили в Steam и отбили инвестиции за месяц",
            description:
                "Как создавалась игра Bult: Hunting Simulator: от зарождения идеи до финальных правок перед релизом. Вы узнаете, какие решения в разработке и продвижении помогли игре окупить все вложения всего за 30 дней в Steam",
        },
        {
            speakers: [
                {
                    name: "Айыына Егорова",
                    avatar: "/assets/speakers/aina_egorova.png",
                    role: "Менеджер продукта Drivee",
                },
            ],
            topic: "Как быстро запускать продукты с нуля: кейсы Drivee",
            description:
                "Разберём реальные кейсы из Drivee: как мы запускали продукты в сжатые сроки — без теории, только практика. Пошагово покажу, как собирать продукт с нуля: от анализа рынка и конкурентов до MVP, оценки задач и формирования roadmap. Детально разберём, как выстроить Scrum: дейли, планирование, груминги и полный цикл разработки",
        },
        {
            speakers: [
                {
                    name: "Ерлан Мурзалин",
                    avatar: "/assets/speakers/yerlan_murzalin.png",
                    role: "Приглашенный гость",
                },
            ],
            topic: "Как раскачать соцсети и делать вирусные видео",
            description:
                "Расскажу на своём примере, как делать ролики с миллионными просмотрами, с чего начать и какие ошибки чаще всего тормозят рост. Покажу, как выстраивать контент, чтобы он разлетался, и на что важно обращать внимание, если хочешь развивать свои соцсети",
        },
        {
            speakers: [
                {
                    name: "Альмира Сейдалова",
                    avatar: "/assets/speakers/almira_seidalova.png",
                    role: "Руководитель отдела маркетинга Ykt",
                },
                {
                    name: "Ксения Олесова",
                    avatar: "/assets/speakers/ksenia_olesova.png",
                    role: "Менеджер по связям с общественностью Ykt",
                },
            ],
            topic: "Один за всех и все за одного: как семь сервисов работают на один большой смысл",
            description:
                "Как семь самостоятельных брендов работают на одну большую идею и при этом не теряют индивидуальность? Расскажем на примере экосистемы YKT, где каждый сервис выполняет свою миссию",
        },
        {
            speakers: [
                {
                    name: "Николай Сивцев",
                    avatar: "/assets/speakers/nikolai_sivkov.png",
                    role: "Директор по маркетингу Додо & Дринкит Якутск",
                },
            ],
            topic: "Додо & Дринкит как система: продукт, люди и технологии",
            description:
                "Поговорим про историю и команду Додо Якутск, про DodoIS как основу бизнеса, про метрики, за которыми мы следим, и про то, как выстроены процессы. И почему Дринкит - больше, чем просто кофе",
        },
        {
            speakers: [
                {
                    name: "Анна Жиркова",
                    avatar: "/assets/speakers/anna_zhirkova.png",
                    role: "Клинический психолог",
                },
            ],
            topic: "7 эмоциональных драйвов для управления мотивацией и профилактики выгограния",
            description:
                "Современные исследования в области клинического нейропсихоанализа выделяют семь ведущих эмоциональных систем (драйвов) в психике человека. С помощью знаний об эмоциональных драйвах можно выстроить эффективную систему мотивации в компании, способствовать личностному росту сотрудников и удовлетворенности работой",
        },
        {
            speakers: [
                {
                    name: "Антон Ломакин",
                    avatar: "/assets/speakers/anton_lomakin.png",
                    role: "Фаундер проекта AVAREANGE",
                },
            ],
            topic: "Term sheet без слёз: краткий курс выживания",
            description:
                "Инвестор сказал «да» — но это только начало. Между рукопожатием и деньгами на счёте лежит term sheet, где каждый пункт может стоить вам доли, контроля или нервов. Ликвидационные преференции, антиразмытие, vesting — звучит сложно, работает ещё сложнее. Разберём на пальцах и реальных примерах: что подписывать спокойно, где торговаться до последнего и почему лучший инвестор — не тот, кто даёт больше денег",
        },
        {
            speakers: [
                {
                    name: "Ерлан Мурзалин",
                    avatar: "/assets/speakers/yerlan_murzalin.png",
                    role: "Приглашенный гость",
                },
            ],
            topic: "Стендап без деплоя: абсурд корпоративного мира + автограф-сессия",
            description:
                "Пообщаемся про ИТ, удалёнку, фейлы, повседневность айтишников\n и не только. Будет весело, но это не точно",
        },
        {
            speakers: [
                {
                    name: "Состав спикеров пополняется",
                    role: "",
                },
            ],
            pending: true,
        },
    ],
    Design: [
        {
            speakers: [
                {
                    name: "Валентина Павлова",
                    avatar: "/assets/speakers/valentina_pavlova.png",
                    role: "Графический дизайнер",
                },
            ],
            topic: "Портфолио есть. Клиентов нет. Почему?",
            description:
                "Почему на одном портфолио не уехать далеко в дизайне. Что еще нужно, чтобы были клиенты (больше фрилансерам и кто хочет во фриланс)",
        },
        {
            speakers: [
                {
                    name: "Кыыдаана Игнатьева",
                    avatar: "/assets/speakers/kydaana_ignatieva.png",
                    role: "Ведущий дизайнер студии Артемия Лебедева",
                },
            ],
            topic: "Как из Якутска устроиться в лучшую дизайн студию России?",
            description:
                "Расскажу про свой путь как я из Якутска устроилась ведущим дизайнером в студию Артемия Лебедева. Поделюсь инсайтами, которые поняла за это время и как построить свой личный бренд",
        },
        {
            speakers: [
                {
                    name: "Ростислав Павлов",
                    avatar: "/assets/speakers/rostislav_pavlov.png",
                    role: "Основатель дизайн-студии «Сулусчан»",
                },
            ],
            topic: "«Путь дизайнера длиной в 20 лет»",
            description:
                "Описание: 20 лет в дизайне: от поиска себя до выгорания. Расскажу не только о классных проектах, но и о темной стороне профессии. Почему это тяжело, неблагодарно, но всё равно стоит того, чтобы продолжать расти и любить дело",
        },
        {
            speakers: [
                {
                    name: "Петр Хики",
                    avatar: "/assets/speakers/peter_hiki.png",
                    role: "Продюсер, режиссер",
                },
                {
                    name: "Виктор Ли-Фу",
                    avatar: "/assets/speakers/victor_li-fu.png",
                    role: "Продюсер, режиссер",
                },
            ],
            topic: "Нейросети в кино и рекламе",
            description:
                "Про якутскую агрегатор-платформу PIKLY.RU. Как разбираться в стремительном развитии ИИ. Куда стремятся гиганты индустрии нейровидео",
        },
        {
            speakers: [
                {
                    name: "Алексей Павлов",
                    avatar: "/assets/speakers/alexey_pavlov.png",
                    role: 'Основатель студии "Пространство"',
                },
            ],
            topic: "От кадра до постера: создание эффектной афиши на основе растровой графики",
            description:
                "Разберем профессиональный пайплайн работы с фотографией в Photoshop. Расскажу, как превратить сырой исходник в качественный рекламный продукт и как дизайнеру составить ТЗ для фотографа, чтобы избежать «грязных» макетов и бесконечных правок",
        },
        {
            speakers: [
                {
                    name: "Яна Петрова",
                    avatar: "/assets/speakers/yana_petrova.png",
                    role: "UX/UI designer Ykt",
                },
            ],
            topic: "Дизайн ради дизайна: как мы тратим время и не влияем на продукт",
            description:
                "Покажу как распознать «дизайн ради дизайна» и перейти к решениям, основанным на гипотезах, метриках и реальной ценности для пользователя",
        },
        {
            speakers: [
                {
                    name: "Состав спикеров пополняется",
                    role: "",
                },
            ],
            pending: true,
        },
    ],
    Data: [
        {
            speakers: [
                {
                    name: "Мичил Егоров",
                    avatar: "/assets/speakers/michiel_egorov.png",
                    role: "Руководитель команды продуктивизации ИИ в X5 Tech",
                },
            ],
            topic: "Правильный RAG на неправильных (реальных) данных",
            description:
                "Расскажу про опыт развития RAG в X5 Tech и как собрать и главное протестировать пайплайн, который точно работает",
        },
        {
            speakers: [
                {
                    name: "Григорий Спиров",
                    avatar: "/assets/speakers/grigory_spirov.png",
                    role: "Руководитель отдела антифрода Drivee",
                },
            ],
            topic: "В тени гигантов. Стартапы на базе готовых AI и путь к мировому масштабу",
            description:
                "Интро в мир стартапов. Вы узнаете, какие инструменты есть, где брать идеи, куда катится мир и как набирать аудиторию, если уже есть стартап. Знакомство с глобальными игроками",
        },
        {
            speakers: [
                {
                    name: "Сайаана Огонерова",
                    avatar: "/assets/speakers/sayana_ogonerova.png",
                    role: "Дата аналитик Kolesa Group",
                },
            ],
            topic: "Как отличить эффект от случайности, если не было A/B-теста (Causal Impact)",
            description:
                "Любой продукт иногда сталкивается с вопросом «А что было бы, если..?». Идеальные A/B-тест не всегда возможны, например, из юридических или этических соображений, из-за влияния внешних факторов, сетевых эффектов. Разберем на реальных кейсах, как отличить реальный эффект от случайных колебаний с помощью методов причинно-следственного анализа (Causal Impact): научимся работать с ковариатами, строить контрфактический сценарий, а также корректно интерпретировать результат без самообмана",
        },
        {
            speakers: [
                {
                    name: "Мичил Егоров",
                    avatar: "/assets/speakers/michiel_egorov.png",
                    role: "Руководитель команды продуктивизации ИИ в X5 Tech",
                },
            ],
            topic: '"Космолет" - как разработать все что угодно за 20 минут',
            description:
                "Покажу на основе Cursor как собрать сайт с фронтендом и бекендом и какие знания требуются для того, чтобы собрать все что угодно",
        },
        {
            speakers: [
                {
                    name: "Георгий Данилов",
                    avatar: "/assets/speakers/georgy_danilov.png",
                    role: "Руководитель отдела аналитики Drivee",
                },
            ],
            topic: "Цинично выбираем жену с помощью матана",
            description:
                "Математическая модель, позволяющая с максимальной вероятностью выбрать лучшее из N предложений, когда вернуться к предыдущему нельзя",
        },
        {
            speakers: [
                {
                    name: "Илья Христофоров",
                    avatar: "/assets/speakers/ilya_khristoforov.png",
                    role: 'Старший разработчик "SmartOm"',
                },
            ],
            topic: "От ручной инфраструктуры к автономной эксплуатации: как мы строим платформу Solomon",
            description:
                'История развития управления инфраструктуры и рассказ о нашем решении в виде собственной платформы ИИ-оператора "Solomon"',
        },
        {
            speakers: [
                {
                    name: "Татьяна Платонова",
                    avatar: "/assets/speakers/tatiana_platonova.png",

                    role: "Директор Лаборатории ИИ Якутии",
                },
            ],
            topic: "Лаборатории ИИ Якутии: чем занимаемся и какие проекты ведем",
            description:
                "Чем занимается Лаборатория ИИ в Республике - баланс исследований и гос задач",
        },
        {
            speakers: [
                {
                    name: "Эрэл Петров",
                    avatar: "/assets/speakers/erel_petrov.png",
                    role: "Менеджер продукта Drivee",
                },
            ],
            topic: "Создание IT-продуктов с помощью ИИ-агентов: мастер-класс для не-разработчиков",
            description:
                "На примере создания расширения для работы с PDF и Telegram-ботов рассмотрим механику взаимодействия с современными ИИ-агентами. Как выстроить процесс от идеи до готового продукта: описание логики, генерация кода и решение проблем. Рассмотрим, как использовать возможности ИИ для сборки своих инструментов",
        },
        {
            speakers: [
                {
                    name: "Анатолий Осипов",
                    avatar: "/assets/speakers/anatoly_osipov.png",
                    role: "Co-founder платформы по внедрению ИИ AccordAI",
                },
            ],
            topic: "Революция в бизнесе Якутии: ИИ-сотрудники, которые работают 24/7, продают и не берут отпуск",
            description:
                "Ключевые тренды ИИ-2026 и главный вопрос бизнеса: как внедрять AI с результатом, а не расходами. Реальные кейсы и практики без воды — что действительно даёт рост продаж и конверсии. Инсайт: Почему AI-бот, понимающий якутский, становится скрытым драйвером конверсии?",
        },
        {
            speakers: [
                {
                    name: "Состав спикеров пополняется",
                    role: "",
                },
            ],
            pending: true,
        },
    ],
    GameDev: [
        {
            speakers: [
                {
                    name: "Пётр Гоголев",
                    avatar: "/assets/speakers/peter_gogolev.png",
                    role: "Директор по развитию креативных индустрий Корпорации развития Якутии",
                },
                {
                    name: "Геннадий Иванов",
                    avatar: "/assets/speakers/gennady_ivanov.png",
                    role: 'Издательство "Новая игра+", проект "Kindawn: The Parish Remembers"',
                },
            ],
            topic: "Фолк-хоррор Kindawn: The Parish Remembers и подробности её создания",
            description:
                "Kindawn переносит в постсоветский северный поселок, где бытовая серость кассетных плееров и заброшек таит шаманские тайны и фольклор таёжные ужасы",
        },
        {
            speakers: [
                {
                    name: "Николай Егоров",
                    avatar: "/assets/speakers/nikolai_egorov.png",
                    role: 'Студия "iLii Games", проект Kyndykan',
                },
            ],
            topic: "Цифровое возрождение культурного наследия: как игра «Кындыкан» спасает историю коренных народов",
            description:
                "Проект «Кындыкан» превращает историю девочки-эвенки, пережившей эпидемию XIX века, в интерактивное приключение. Пример того, как ИТ-технологии возрождают культурное наследие малочисленных народов",
        },
        {
            speakers: [
                {
                    name: "Иннокентий Слепцов",
                    avatar: "/assets/speakers/innokenty_sleptsov.png",
                    role: 'Студия "Rubedo Games", проект Soulbind: Tales Of The Underworld и проект  Тартария',
                },
            ],
            topic: "Тартария: пошаговая RTS выживания в средневековом Севере",
            description:
                "Пошаговая стратегия «Тартария» сочетает исторический сеттинг раннего Средневековья на Севере с механиками выживания и клановой политикой. Игрокам предстоит развивать поселения в суровых условиях, управляя ресурсами и балансом сил между фракциями",
        },
        {
            speakers: [
                {
                    name: "Петр Ноговицын",
                    avatar: "/assets/speakers/peter_nogovitsyn.png",
                    role: 'Издательство "Cryolite Games", проекты Cake Up, 412th, HAAR, Namae Den Yume',
                },
            ],
            topic: "Презентация проектов издательства Cryolite Games Studio",
            description:
                "Видеоигровое издательство Cryolite Games Studio разрабатывает самые различные проекты: от визуальной новеллы Namae Den Yume, до шутера в суровом климате HAAR",
        },
        {
            speakers: [
                {
                    name: "Алексей Максимов",
                    avatar: "/assets/speakers/alexey_maksimov.png",
                    role: 'Издательство "Новая Игра+", проект "UMAI"',
                },
            ],
            topic: "Презентация приключенческой головоломки UMAI",
            description:
                "UMAI - это медитативное приключение, где игрок пробуждает весну в заснеженном мире, управляя стихиями и решая головоломки, вдохновлённые мифологией северных народов",
        },
        {
            speakers: [
                {
                    name: "Игорь Худаев",
                    avatar: "/assets/speakers/igor_khudaev.png",
                    role: 'Студии Go North и Verarium, проект "Spears & Spirits"',
                },
            ],
            topic: "Презентация проекта Spears & Spirits: История и фэнтези",
            description: "Первый взгляд на игру с подробностями про сеттинг и механики",
        },
        {
            speakers: [
                {
                    name: "Иннокентий Слепцов",
                    avatar: "/assets/speakers/innokenty_sleptsov.png",
                    role: 'Студия "Rubedo Games", проект Soulbind: Tales Of The Underworld и проект  Тартария',
                },
            ],
            topic: "Возможности использование AI в видеоиграх",
            description:
                "Использование AI инструментария в разработке игр. Разбор кейсов из Soulbind: Tales of the Underworld и Tartaria: Frozen Frontline",
        },
        {
            speakers: [
                {
                    name: "Игорь Худаев",
                    avatar: "/assets/speakers/igor_khudaev.png",
                    role: 'Студии Go North и Verarium, проект "Spears & Spirits"',
                },
            ],
            topic: "Разработка видеоигр: От идеи к MVP",
            description:
                "Краткое описание рабочей методологии для претворения идей в осязаемый продукт. С чего начать, какими принципами руководствоваться, как не развалиться по пути",
        },
        {
            speakers: [
                {
                    name: "Состав спикеров пополняется",
                    role: "",
                },
            ],
            pending: true,
        },
    ],
    "Войти в IT": [
        {
            speakers: [
                {
                    name: "Елизавета Теслюк",
                    avatar: "/assets/speakers/elizaveta_teslyuk.png",
                    role: "Старший партнер по работе с ИТ-талантами Drivee",
                },
            ],
            topic: "Не только разработка: какие профессии есть в IT и как выбрать своё направление",
            description:
                "Многие хотят “войти в IT”, но не всегда понимают, что именно скрывается за этим словом. На выступлении разберём основные направления в IT, актуальные профессии, реальные точки входа для новичков и то, как выбрать не самую модную, а подходящую именно вам роль",
        },
        {
            speakers: [
                {
                    name: "Александра Захарова",
                    avatar: "/assets/speakers/sasha_zakharova.png",
                    role: "Продуктовый дизайнер Drivee",
                },
            ],
            topic: "Почему ваши идеальные макеты никому не нужны?",
            description:
                "Многие до сих пор думают, что продуктовый дизайнер — это человек, который 8 часов рисует в Figma. Но на самом деле отрисовка интерфейсов — это лишь около 20% работы",
        },
        {
            speakers: [
                {
                    name: "Павел Танин",
                    avatar: "/assets/speakers/pavel_tanin.png",
                    role: "Системный аналитик АЭБ",
                },
            ],
            topic: 'Как писать ТЗ в эфире НВК "Саха" и почему старый опыт лучше курсов',
            description:
                "Путь от ведущего новостей до системного аналитика: почему в IT важны не только программисты. О том, как старый профессиональный опыт становится прочным фундаментом для развития в абсолютно новой сфере",
        },
        {
            speakers: [
                {
                    name: "Анастасия Иванова",
                    avatar: "/assets/speakers/anastasia_ivanova.png",
                    role: "Директор по развитию ГК УТУМ+",
                },
            ],
            topic: "Как компании и бренды думают. И что с этим делать",
            description:
                "Большинство IT-курсов учат делать, но не учат, как устроена компания, которая будет тебя нанимать. Разберем, как на самом деле принимаются решения внутри, что такое язык решений и как выстроить карьерный путь, который интересен сам по себе",
        },
        {
            speakers: [
                {
                    name: "Валерия Яковлева",
                    avatar: "/assets/speakers/valeria_yakovleva.png",
                    role: 'Комьюнити-менеджер "Школы 21"',
                },
            ],
            topic: "Код, который объединяет: как ИТ-сообщество становится “местом силы” (и при чем тут бассейн)",
            description:
                "ИT-комьюнити — это не просто «тусовка в телеграм-чате». В Школе 21 оно строится на принципе «сначала мы проходим ад вместе, потом вместе растем». Настоящее комьюнити рождается там, где есть общий вызов, а не только общие интересы",
        },
        {
            speakers: [
                {
                    name: "Татьяна Стручкова",
                    avatar: "/assets/speakers/tatiana_struchkova.png",
                    role: "Руководитель отдела проверки качества Drivee",
                },
            ],
            topic: "Войти в IT через QA - или сразу выбрать свой путь?",
            description:
                "Есть мнение, что QA - это простой вход в IT с возможностью «разобраться потом». Но текущие реалии требуют более осознанного подхода. Разберем, какие есть пути развития и что на самом деле требуют от современного QA инженера",
        },
        {
            speakers: [
                {
                    name: "Гаврил Слепцов",
                    avatar: "/assets/speakers/gavril_sleptsov.png",
                    role: "Инженер отдела антифрода Drivee",
                },
            ],
            topic: "Как я учусь в ИМИ СВФУ и работаю в Drivee и: Кто такой antifraud инженер и чем он занимается?",
            description:
                "Расскажу свой путь: как попал в IT, с какими трудностями столкнулся. Поделюсь ресурсами, советами по прокачке навыков и тем, как не выгореть по пути",
        },
        {
            speakers: [
                {
                    name: "Валерий Крупенков",
                    avatar: "/assets/speakers/valery_krupenkov.png",
                    role: 'Исполнительный директор ООО "Криолит геймс"',
                },
            ],
            topic: "«Когда чувствуешь, что это твоё: как найти талант в IT, если ты начинал в другой сфере»",
            description:
                'Накопил более 15 лет опыта в энергетике, нефтегазовой отрасли и производстве. В марте 2022 года перешёл в IT-сферу, возглавив отдел ИТ-Парка в Якутске, где участвовал в организации 25+ форумов, за это время оценил 900+ стартапов и вывел проекты на федеральные платформы. Сейчас он — исполнительный директор ООО "Криолит геймс", проводит IT-митапы и лекции по стартапам, а также автор книги «68 ошибок стартапера» и эксперт по акселерации проектов (оценил 1700+ идей)',
        },
        {
            speakers: [
                {
                    name: "Уйгууна Михайлова",
                    avatar: "/assets/speakers/uyguna_mikhailova.png",
                    role: "Инженер отдела разработки Drivee",
                },
            ],
            topic: "Мой путь в IT: честно про сложности, мотивацию и первую работу",
            description:
                "История о том, как я пришла в IT без технического образования. Поделюсь, как и где я училась, с какими трудностями столкнулась. Выступление будет полезно тем, кто думает о переходе в IT или уже учится и сталкивается с сомнениями на старте",
        },
        {
            speakers: [
                {
                    name: "Сергей Вышкварок",
                    avatar: "/assets/speakers/sergey_vyshkvarok.png",
                    role: "Инженер отдела проверки качества Ykt",
                },
            ],
            topic: "Путь самурая: реально ли в 46 начать изучать ИТ и устроиться в ИТ компанию",
            description:
                "Честно расскажу свой путь изучения ИТ после 40. Практика, стажировка и трудоустройство в Ykt",
        },
        {
            speakers: [
                {
                    name: "Алгыс Булдаков",
                    avatar: "/assets/speakers/algys_buldakov.png",
                    role: "Cтарший инженер отдела бэкенд разработки Drivee",
                },
            ],
            topic: "Бэкенд с нуля: как войти в IT бэкэнд разработчиком?",
            description:
                "Бэкенд-разработка — это основа любого приложения: именно здесь обрабатываются данные, логика и запросы пользователей. На выступлении разберём, как с нуля войти в backend и какие навыки нужны",
        },
        {
            speakers: [
                {
                    name: "Слепцова Марианна",
                    avatar: "/assets/speakers/sleptsova_marianna.png",
                    role: "Руководитель Регионального центра обсулживания г. Якутск АЛРОСА ИТ",
                },
                {
                    name: "Иванов Петр",
                    avatar: "/assets/speakers/peter_ivanov.png",
                    role: "Главный специалист Группы поддержки пользователей г. Якутск АЛРОСА ИТ",
                },
            ],
            topic: "Организация ИТ сервиса в крупных корпорациях: ITSM, метрики, ценности",
            description:
                "Как выглядит работа ИТ - службы, когда ИТ выступает обеспечивающией функцией для большого производства. Организация и управление сервисом в условиях большого пула разнокалиберных задачи заказчиков",
        },
        {
            speakers: [
                {
                    name: "Эдуард Павлов",
                    avatar: "/assets/speakers/eduard_pavlov.png",
                    role: "Аналитик данных Drivee",
                },
            ],
            topic: "Как устроиться аналитиком данных в 20 лет",
            description:
                "Мой путь с нуля до оффера в крупной компании. Расскажу, с чего я начинал, какие навыки пришлось осваивать, с какими трудностями и подводными камнями столкнулся, и какие выводы сделал по пути. Также поделюсь советами, которые могут помочь тем, кто хочет начать карьеру в аналитике как можно раньше",
        },
        {
            speakers: [
                {
                    name: "Артём Иванов",
                    avatar: "/assets/speakers/artyom_ivanov.png",
                    role: "Инженер по автоматизированному тестированию Vk Tech",
                },
            ],
            topic: "Программа развития VK MidSprint - твой билет в IT",
            description:
                "Расскажу на собственном примере как запустить карьеру в одной из крупнейших bigtech-компаний",
        },
        {
            speakers: [
                {
                    name: "Елизавета Теслюк",
                    avatar: "/assets/speakers/elizaveta_teslyuk.png",
                    role: "Старший партнер по работе с ИТ-талантами Drivee",
                },
            ],
            topic: "Как реально нанимают в IT: на что смотрят работодатели, где ошибаются кандидаты и что делать завтра",
            description:
                "Почему одним кандидатам отвечают, а другим — нет, даже если по резюме они вроде бы похожи? Разберём найм в IT глазами работодателя: на что реально смотрят в резюме, как оценивают на собеседованиях и каких ошибок стоит избегать кандидату. В конце — конкретные шаги, что можно сделать уже завтра, чтобы стать сильнее как кандидат",
        },
        {
            speakers: [
                {
                    name: "Мария Степанова",
                    avatar: "/assets/speakers/maria_stepanova.png",
                    role: "Backend-разработчик Wildberries",
                },
            ],
            topic: "От идеи к движению: история сообщества She’s in Tech",
            description:
                "Это история о том, как личный опыт и нехватка поддержки в IT привели к созданию сообщества She’s in Tech. Я расскажу, как появилась идея, как формировалось сообщество, какие форматы мы запустили и каких результатов уже достигли. Также поделюсь вызовами, с которыми мы столкнулись и поговорим о том, почему важно создавать поддерживающее пространство для женщин в IT. Это выступление про инициативу, рост и силу объединения",
        },
        {
            speakers: [
                {
                    name: "Борис Харанутов",
                    avatar: "/assets/speakers/boris_kharanutov.png",
                    role: "Геймдев разработчик",
                },
            ],
            topic: "История создания игры в Roblox*, в которую сыграли более 1 000 000 000 раз",
            description:
                "Расскажу свой путь от создания первой игры в Roblox* до Scary Shawarma Kiosk The Anomaly, которую сыграли уже больше миллиарда раз. \n*Roblox заблокирован на территории РФ",
        },
        {
            speakers: [
                {
                    name: "Мичил Стручков",
                    avatar: "/assets/speakers/michiel_struchkov.png",
                    role: "Генеральный директор АНО Дирекция конкурса «Моя профессия – ИТ»",
                },
            ],
            topic: "Конкурс «Моя профессия – ИТ» — драйвер развития ИТ: от республики к стране. Истории роста участников, реальные проекты и новые возможности",
            description:
                "Конкурс открывает участникам реальные возможности роста в ИТ через практические кейсы и командные проекты, помогает получать опыт, развиваться в профессии, находить компанию мечты и формирует сильное профессиональное сообщество",
        },
        {
            speakers: [
                {
                    name: "Иванов Алексей",
                    avatar: "/assets/speakers/ivanov_alexey.png",
                    role: "Ведущий специалист направления специализированных ИС АЛРОСА ИТ",
                },
            ],
            topic: "Разработка внутренних продуктов для большого бизнеса",
            description:
                "Как проходит разработка ИТ продуктов для внутренних задач бизнеса. Практика разработчика портала по целеполаганию",
        },
        {
            speakers: [
                {
                    name: "Состав спикеров пополняется",
                    role: "",
                },
            ],
            pending: true,
        },
    ],
};

type ScheduleSlot = Omit<ProgramItem, "speakers" | "topic">;

function getSpeakerCard(
    tab: TrackTab,
    matcher: {
        topic?: string;
        speakerName?: string;
    }
): SpeakerCardItem {
    const item = speakersByTab[tab].find((candidate) => {
        const hasTopicMatch = matcher.topic ? candidate.topic === matcher.topic : true;
        const hasSpeakerMatch = matcher.speakerName
            ? candidate.speakers.some((speaker) => speaker.name === matcher.speakerName)
            : true;

        return hasTopicMatch && hasSpeakerMatch;
    });

    if (!item || item.pending) {
        throw new Error(
            `Program source is missing for track "${tab}" and matcher ${JSON.stringify(matcher)}`
        );
    }

    return item;
}

function talkSlot(
    tab: TrackTab,
    matcher: {
        topic?: string;
        speakerName?: string;
    },
    slot: ScheduleSlot
): ProgramItem {
    const item = getSpeakerCard(tab, matcher);

    return {
        ...slot,
        speakers: item.speakers.map((speaker) => ({ ...speaker })),
        topic: item.topic?.trim() || matcher.topic || "Тема уточняется",
    };
}

function breakSlot(time: string, topic: string): ProgramItem {
    return {
        time,
        topic,
        break: true,
    };
}

export const programByTab: Record<TrackTab, ProgramItem[]> = {
    Development: [
        breakSlot("12:00-12:30", "Открытие конференции. Зал Ивент"),
        talkSlot(
            "Development",
            { speakerName: "Иван Григорьев" },
            { time: "12:30-13:05", place: "Библиотека" }
        ),
        talkSlot(
            "Development",
            { speakerName: "Станислав Павлов" },
            { time: "13:05-13:40", place: "Библиотека" }
        ),
        talkSlot(
            "Development",
            { speakerName: "Владимир Заморщиков" },
            { time: "13:40-14:15", place: "Библиотека" }
        ),
        talkSlot(
            "Development",
            { speakerName: "Артем Лыткин" },
            { time: "14:15-14:50", place: "Библиотека" }
        ),
        talkSlot(
            "Development",
            { speakerName: "Мария Степанова" },
            { time: "14:50-15:25", place: "Библиотека" }
        ),
    ],
    Management: [
        breakSlot("12:00-12:30", "Открытие конференции. Зал Ивент"),
        talkSlot(
            "Management",
            { speakerName: "Матвей Бадагуев" },
            { time: "12:30-13:05", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            { speakerName: "Сергей Протопопов" },
            { time: "13:05-13:40", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            { speakerName: "Денис Захаров" },
            { time: "13:40-14:15", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            { speakerName: "Владислав Петров" },
            { time: "14:15-14:50", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            { speakerName: "Айыына Егорова" },
            { time: "14:50-15:25", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            { speakerName: "Ерлан Мурзалин" },
            { time: "15:25-16:00", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            { speakerName: "Альмира Сейдалова" },
            { time: "16:00-16:35", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            { speakerName: "Николай Сивцев" },
            { time: "16:35-17:10", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            { speakerName: "Анна Жиркова" },
            { time: "17:10-17:45", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            { speakerName: "Антон Ломакин" },
            { time: "17:45-18:20", place: "Ивент" }
        ),
        talkSlot(
            "Management",
            {
                speakerName: "Ерлан Мурзалин",
                topic: "Стендап без деплоя: абсурд корпоративного мира + автограф-сессия",
            },
            { time: "18:20-18:55", place: "Ивент" }
        ),
        breakSlot(
            "19:00-21:00",
            "Закрытие конференции и концертная программа с участием: Еlements of dust, Букет Бумажных Цветов, Yoppa, Junk и др. Зал Ивент"
        ),
    ],
    Design: [
        breakSlot("12:00-12:30", "Открытие конференции. Зал Ивент"),
        talkSlot(
            "Design",
            { speakerName: "Валентина Павлова" },
            { time: "15:25-16:00", place: "Библиотека" }
        ),
        talkSlot(
            "Design",
            { speakerName: "Кыыдаана Игнатьева" },
            { time: "16:00-16:35", place: "Библиотека" }
        ),
        talkSlot(
            "Design",
            { speakerName: "Ростислав Павлов" },
            { time: "16:35-17:10", place: "Библиотека" }
        ),
        talkSlot(
            "Design",
            { speakerName: "Петр Хики" },
            { time: "17:10-17:45", place: "Библиотека" }
        ),
        talkSlot(
            "Design",
            { speakerName: "Алексей Павлов" },
            { time: "17:45-18:20", place: "Библиотека" }
        ),
        talkSlot(
            "Design",
            { speakerName: "Яна Петрова" },
            { time: "18:20-18:55", place: "Библиотека" }
        ),
        breakSlot(
            "19:00-21:00",
            "Закрытие конференции и концертная программа с участием: Еlements of dust, Букет Бумажных Цветов, Yoppa, Junk и др. Зал Ивент"
        ),
    ],
    Data: [
        breakSlot("12:00-12:30", "Открытие конференции. Зал Ивент"),
        talkSlot(
            "Data",
            {
                speakerName: "Мичил Егоров",
                topic: "Правильный RAG на неправильных (реальных) данных",
            },
            { time: "12:30-13:05", place: "Песочница" }
        ),
        talkSlot(
            "Data",
            { speakerName: "Григорий Спиров" },
            { time: "13:05-13:40", place: "Песочница" }
        ),
        talkSlot(
            "Data",
            { speakerName: "Сайаана Огонерова" },
            { time: "13:40-14:15", place: "Песочница" }
        ),
        talkSlot(
            "Data",
            {
                speakerName: "Мичил Егоров",
                topic: '"Космолет" - как разработать все что угодно за 20 минут',
            },
            { time: "14:15-14:50", place: "Песочница" }
        ),
        breakSlot("14:50-15:25", "Перерыв на нетворк"),
        talkSlot(
            "Data",
            { speakerName: "Георгий Данилов" },
            { time: "15:25-16:00", place: "Песочница" }
        ),
        talkSlot(
            "Data",
            { speakerName: "Илья Христофоров" },
            { time: "16:00-16:35", place: "Песочница" }
        ),
        talkSlot(
            "Data",
            { speakerName: "Татьяна Платонова" },
            { time: "16:35-17:45", place: "Песочница" }
        ),
        talkSlot(
            "Data",
            { speakerName: "Эрэл Петров" },
            { time: "17:45-18:20", place: "Песочница" }
        ),
        talkSlot(
            "Data",
            { speakerName: "Анатолий Осипов" },
            { time: "18:20-18:55", place: "Песочница" }
        ),
        breakSlot(
            "19:00-21:00",
            "Закрытие конференции и концертная программа с участием: Еlements of dust, Букет Бумажных Цветов, Yoppa, Junk и др. Зал Ивент"
        ),
    ],
    GameDev: [
        breakSlot(
            "11:00-15:00",
            "Турнир по CS2. Призовой фонд 100к + мерч от Drivee и HOTU. Зал Кибер-арена."
        ),
        breakSlot("12:00-12:30", "Открытие конференции. Зал Ивент."),
        breakSlot(
            "15:30-19:00",
            'Параллельно с выступлениями турнир по "Bult: Hunting Simulator": кто добудет больше всех уток за 30 минут. Билды на компах с демо-версиями якутских игр. Зал Кибер-арена.'
        ),
        talkSlot(
            "GameDev",
            { speakerName: "Пётр Гоголев" },
            { time: "15:40-15:50", place: "Кибер-арена" }
        ),
        talkSlot(
            "GameDev",
            { speakerName: "Николай Егоров" },
            { time: "15:50-16:00", place: "Кибер-арена" }
        ),
        talkSlot(
            "GameDev",
            { speakerName: "Иннокентий Слепцов" },
            { time: "16:00-16:10", place: "Кибер-арена" }
        ),
        talkSlot(
            "GameDev",
            { speakerName: "Петр Ноговицын" },
            { time: "16:10-16:20", place: "Кибер-арена" }
        ),
        talkSlot(
            "GameDev",
            { speakerName: "Алексей Максимов" },
            { time: "16:20-16:30", place: "Кибер-арена" }
        ),
        talkSlot(
            "GameDev",
            { speakerName: "Игорь Худаев" },
            { time: "16:30-16:40", place: "Кибер-арена" }
        ),
        talkSlot(
            "GameDev",
            {
                speakerName: "Иннокентий Слепцов",
                topic: "Возможности использование AI в видеоиграх",
            },
            { time: "16:40-17:10", place: "Кибер-арена" }
        ),
        // {
        //     time: "16:40-17:10",
        //     place: "Кибер-арена",
        //     topic: "Как рождается игровой процесс",
        //     speakers: [
        //         {
        //             name: "Геймдизайн и основные игровые механики",
        //             role: "Обучение",
        //         },
        //     ],
        // },
        talkSlot(
            "GameDev",
            { speakerName: "Игорь Худаев", topic: "Разработка видеоигр: От идеи к MVP" },
            { time: "17:10-17:40", place: "Кибер-арена" }
        ),
        breakSlot(
            "19:00-21:00",
            "Закрытие конференции и концертная программа с участием: Еlements of dust, Букет Бумажных Цветов, Yoppa, Junk и др. Зал Ивент."
        ),
    ],
    "Войти в IT": [
        breakSlot("12:00-12:30", "Открытие конференции. Зал Ивент"),
        talkSlot(
            "Войти в IT",
            { speakerName: "Елизавета Теслюк" },
            { time: "12:30-13:05", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Александра Захарова" },
            { time: "13:05-13:40", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Павел Танин" },
            { time: "13:05-13:40", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Анастасия Иванова" },
            { time: "13:40-14:15", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Валерия Яковлева" },
            { time: "14:15-14:50", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Татьяна Стручкова" },
            { time: "14:15-14:50", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Гаврил Слепцов" },
            { time: "14:50-15:25", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Валерий Крупенков" },
            { time: "14:50-15:25", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Уйгууна Михайлова" },
            { time: "15:25-16:00", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Сергей Вышкварок" },
            { time: "15:25-16:00", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Алгыс Булдаков" },
            { time: "16:00-16:35", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Слепцова Марианна" },
            { time: "16:00-16:35", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Эдуард Павлов" },
            { time: "16:35-17:10", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Артём Иванов" },
            { time: "16:35-17:10", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            {
                speakerName: "Елизавета Теслюк",
                topic: "Как реально нанимают в IT: на что смотрят работодатели, где ошибаются кандидаты и что делать завтра",
            },
            { time: "17:10-17:45", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Мария Степанова" },
            { time: "17:45-18:20", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Борис Харанутов" },
            { time: "17:45-18:20", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Мичил Стручков" },
            { time: "18:20-18:55", place: "Лекторий" }
        ),
        talkSlot(
            "Войти в IT",
            { speakerName: "Иванов Алексей" },
            { time: "18:20-18:55", place: "Лекторий" }
        ),
        breakSlot(
            "19:00-21:00",
            "Закрытие конференции и концертная программа с участием: Еlements of dust, Букет Бумажных Цветов, Yoppa, Junk и др. Зал Ивент"
        ),
    ],
};

export const sponsorLogos: readonly SponsorLogo[] = [
    { src: "/assets/partners/sponsor-01.png", alt: "Drivee", width: 319, height: 132 },
    { src: "/assets/partners/sponsor-02.png", alt: "Ykt", width: 293, height: 123 },
    { src: "/assets/partners/sponsor-03.png", alt: "АЭБ", width: 327, height: 112 },
    { src: "/assets/partners/sponsor-04.png", alt: "Додо Пицца", width: 386, height: 130 },
    { src: "/assets/partners/sponsor-05.png", alt: "КР РС(Я)", width: 127, height: 126 },
    { src: "/assets/partners/sponsor-06.png", alt: "NRG", width: 242, height: 102 },
    { src: "/assets/partners/sponsor-07.png", alt: "ЦОПП", width: 118, height: 120 },
    { src: "/assets/partners/sponsor-08.png", alt: "Квартал труда", width: 539, height: 59 },
    { src: "/assets/partners/sponsor-09.png", alt: "Азия", width: 171, height: 112 },
    { src: "/assets/partners/sponsor-12.png", alt: "СЭТТЭ", width: 398, height: 121 },
    // { src: "/assets/partners/sponsor-13.png", alt: "���", width: 643, height: 643 },
] as const;

export const friendLogos: readonly SponsorLogo[] = [
    { src: "/assets/friends/friend-01.png", alt: "Boon Market", width: 117, height: 30 },
    { src: "/assets/friends/friend-02.png", alt: "Школа 21", width: 89, height: 59 },
    { src: "/assets/friends/friend-03.png", alt: "The is in Tech", width: 742, height: 336 },
    { src: "/assets/friends/friend-04.png", alt: "Сулусчан", width: 48, height: 48 },
    { src: "/assets/friends/friend-05.png", alt: "Пространство", width: 167, height: 23 },
    { src: "/assets/friends/friend-06.png", alt: "Avatek", width: 143, height: 39 },
    { src: "/assets/friends/friend-07.png", alt: "VK Tech", width: 111, height: 36 },
    { src: "/assets/friends/friend-08.png", alt: "SmartOm", width: 190, height: 36 },
    { src: "/assets/friends/friend-09.png", alt: "Cryolite Games Studio", width: 56, height: 56 },
    { src: "/assets/friends/friend-10.png", alt: "Новая игра", width: 144, height: 56 },
    { src: "/assets/friends/friend-11.png", alt: "ЯО ФКС РФ", width: 92, height: 58 },
    { src: "/assets/friends/friend-12.png", alt: "friend-12", width: 96, height: 56 },
    { src: "/assets/friends/friend-13.png", alt: "Ilii Games", width: 94, height: 58 },
    { src: "/assets/friends/friend-14.png", alt: "Rubedo Games", width: 94, height: 60 },
    { src: "/assets/friends/friend-15.png", alt: "Nordrise", width: 174, height: 60 },
    { src: "/assets/friends/friend-16.png", alt: "Saqa omuk", width: 248, height: 27 },
    { src: "/assets/friends/friend-17.png", alt: "YktGames", width: 124, height: 74 },
    { src: "/assets/friends/friend-18.png", alt: "Bult", width: 181, height: 69 },
    {
        src: "/assets/friends/friend-19.png",
        alt: "Институт математики и информатики СВФУ",
        width: 79,
        height: 79,
    },
] as const;

export const merchCards: readonly MerchCard[] = [
    {
        title: "Drivee x Saqa Omuk",
        accent: "dark",
        image: "/saqa_merch.png",
        imageAlt: "Черная футболка с вопросительным знаком",
    },
    {
        title: "Фирменный мерч от партнеров",
        accent: "green",
        image: "/main_merch.png",
        imageAlt:
            "Фирменный мерч от партнеров: рюкзак, термос, бананка, бутылка, плед, шнурок и значок",
        description:
            "На конференции было много активностей и игр от партнеров конференции, участвуя в которых, участники получали фирменный мерч",
    },
] as const;

export const assets: AssetsMap = {
    logo: "/logo.png",
    avatar: speakerAvatar,
    plusIcon: "/assets/plus-icon.svg",
    cube: "/assets/cube-animated.webp",
    map: "/assets/map-animated.webp",
    figure1: "/assets/figure1-animated.webp",
    figure1Poster: "/assets/figure1-poster.webp",
    merchCard: "/assets/merch_card.png",
    merchBirk: "/assets/merch_birk.png",
};

export const conferenceHighlights = [
    { value: "3500+", label: "участников." },
    { value: "60+", label: "спикеров из ведущих тех-компаний." },
    { value: "6", label: "разных треков." },
    { value: "2000+", label: "единиц бесплатного мерча за активности." },
    { value: "6", label: "рок-групп, создавших атмосферу финала." },
    { value: "1", label: "общая цель — процветание ИТ-индустрии республики." },
] as const;

export const recapVideos = [
    {
        id: "driveecon",
        title: "DriveeCon",
        src: "/media/driveecon-2026/driveecon.mp4",
        poster: "/media/driveecon-2026/driveecon.jpg",
        fallbackUrl: "https://disk.360.yandex.ru/i/h1jhjwdqZYMF5w",
    },
    {
        id: "it-driveecon",
        title: "ИТ DRIVEECON",
        src: "/media/driveecon-2026/it-driveecon.mp4",
        poster: "/media/driveecon-2026/it-driveecon.jpg",
        fallbackUrl: "https://disk.360.yandex.ru/i/6t9JGeCEIide_Q",
    },
] as const;
